<template>
  <div style="width: 100%; height: 100%; border-radius: 1rem; overflow: hidden;">
    <slot></slot>
  </div>
</template>
